
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { FormControl } from "@/components/ui/form";
import { EditorToolbar } from "./editor/EditorToolbar";
import { EditorContent } from "./editor/EditorContent";

interface HtmlEditorProps {
  name: string;
  placeholder?: string;
  className?: string;
}

export const HtmlEditor: React.FC<HtmlEditorProps> = ({
  name,
  placeholder = "",
  className = "",
}) => {
  const { setValue, watch } = useFormContext();
  const value = watch(name) || "";
  const [isFocused, setIsFocused] = React.useState(false);
  const editorRef = React.useRef<HTMLDivElement>(null);

  const handleCommand = (command: string, value: string | null = null) => {
    document.execCommand(command, false, value);
    if (editorRef.current) {
      const content = editorRef.current.innerHTML;
      setValue(name, content, { shouldDirty: true });
    }
  };

  // Initialize the editor content when the component mounts
  useEffect(() => {
    if (editorRef.current && !isFocused) {
      editorRef.current.innerHTML = value;
    }
  }, []);

  // Handle input changes and update form value
  const handleInput = () => {
    if (editorRef.current) {
      const content = editorRef.current.innerHTML;
      setValue(name, content, { shouldDirty: true });
    }
  };

  return (
    <div className="flex flex-col border rounded-md overflow-hidden">
      <EditorToolbar onCommand={handleCommand} />
      <FormControl>
        <EditorContent
          editorRef={editorRef}
          value={value}
          placeholder={placeholder}
          className={className}
          handleInput={handleInput}
          isFocused={isFocused}
          setIsFocused={setIsFocused}
        />
      </FormControl>
    </div>
  );
};
